export const DISTRIBUTE_AI_BASE_URL = 'https://ai.ideaflow.pro'
export const DISTRIBUTE_UNSUPPORTED_MESSAGE = '请在造梦次元 App 操作'
export const DISTRIBUTE_ANCHOR_LABEL = '点击进入互动'
export const DISTRIBUTE_FEED_SKELETON_RATIOS = [
  '10 / 16',
  '3 / 4',
  '16 / 10',
  '3 / 4',
  '10 / 16',
  '16 / 10',
]
export const DISTRIBUTE_FEED_MIN_COLUMN_WIDTH = 260
export const DISTRIBUTE_FEED_SINGLE_COLUMN_MAX_WIDTH = 720
export const DISTRIBUTE_FEED_LOAD_MORE_ROOT_MARGIN = '2600px 0px'
export const DISTRIBUTE_FEED_PAGING_SKELETON_MIN_DURATION = 320
export const DISTRIBUTE_FEED_NEXT_PAGE_VISUAL_READY_COUNT = 4
export const DISTRIBUTE_FEED_NEXT_PAGE_VISUAL_READY_TIMEOUT = 2800
export const DISTRIBUTE_FEED_EMPTY_PAGE_AUTOFILL_LIMIT = 3
export const DISTRIBUTE_FEED_AUTOPLAY_ACTIVE_LIMIT = 4
export const DISTRIBUTE_FEED_AUTOPLAY_CONSTRAINED_ACTIVE_LIMIT = 2
export const DISTRIBUTE_FEED_END_TEXT = '没有内容了'
export const DISTRIBUTE_FEED_LOGIN_PROMPT_TEXT = '登录后查看更多内容'
export const DISTRIBUTE_FEED_LOGIN_ACTION_TEXT = '登录造梦次元'
export const DISTRIBUTE_FEED_ITEM_RENDER_ROOT_MARGIN = '1800px 0px'
export const DISTRIBUTE_FEED_PRIORITY_ITEM_COUNT = 8
export const DISTRIBUTE_MEDIA_VISIBILITY_THRESHOLD = 0.12
export const DISTRIBUTE_MEDIA_PRELOAD_ROOT_MARGIN = '1000px 0px'
export const DISTRIBUTE_MEDIA_PLAY_THRESHOLD = 0.32
export const DISTRIBUTE_MEDIA_PAUSE_THRESHOLD = 0.06
export const DISTRIBUTE_MEDIA_INTERSECTION_THRESHOLDS = [
  0,
  DISTRIBUTE_MEDIA_PAUSE_THRESHOLD,
  DISTRIBUTE_MEDIA_VISIBILITY_THRESHOLD,
  DISTRIBUTE_MEDIA_PLAY_THRESHOLD,
  0.6,
  1,
] as const
export const DISTRIBUTE_IMAGE_AUTOPLAY_INTERVAL = 2800
export const DISTRIBUTE_BGM_DEFAULT_COVER_URL = 'https://img.ideaflow.pro/default/vinyl.png'
export const DISTRIBUTE_LIKE_FEEDBACK_DURATION = 520
export const DISTRIBUTE_PREVIEW_HINT = '悬停预览'
export const DISTRIBUTE_CARD_DEFAULT_TITLE = 'Dreama 内容'
export const DISTRIBUTE_CARD_DEFAULT_AUTHOR = 'Dreama 创作者'

export const DISTRIBUTE_RADIO_COPY = {
  fallbackLine: '点击听完整版本',
  fallbackTitle: 'Dreama Radio',
} as const

export const DISTRIBUTE_EMPTY_COPY = {
  chip: '暂无内容',
  title: '这条发现流暂时安静',
  description: '可以稍后再刷新，或者切回 UAT 环境继续验证更多卡片类型。',
} as const

export const DISTRIBUTE_ERROR_COPY = {
  chip: '请求失败',
  title: '发现流暂时未能连接',
  compactTitle: '分页加载出了点问题',
  action: '重新加载',
  defaultMessage: '网络错误',
} as const
